export const GROUP_A = [
  [
    { ratioGroupCode: 'CapitalAdequacy' },
    { ratioGroupCode: 'FundingLiquidity' },
  ],
  [{ ratioCode: 'NB219' }, { ratioCode: 'RT0277' }],
  [{ ratioGroupCode: 'AssetsQuality' }, { ratioCode: 'FA110' }],
  [{ ratioCode: 'FA146' }, {}],
]

export const GROUP_B = [
  [
    { ratioGroupCode: 'FundingLiquidity' },
    { ratioGroupCode: 'EarningQuality' },
  ],
  [{ ratioCode: 'RT0277' }, { ratioCode: 'FA150' }],
  [{ ratioCode: 'RT0295' }, { ratioCode: 'RT0252' }],
  [{ ratioCode: ' ' }, { ratioCode: 'RT0059' }],
  [{ ratioGroupCode: 'BusinessGrowth' }, { ratioGroupCode: 'AssetsQuality' }],
  [{ ratioCode: 'RT0296' }, { ratioCode: 'FA146' }],
  [{ ratioCode: 'FA151' }, { ratioCode: 'FA147' }],
  [{ ratioCode: 'RT0172' }, { ratioCode: 'FA110' }],
]
